import PropTypes from 'prop-types'
import React from 'react'
import useProductPricing from '../../hooks/use-product-pricing'
import DisplayPrice from '../display-price'
import {useCommerceData} from '../../hooks/use-commerce-data'

const ProductDisplayPrice = ({
    as: Component = DisplayPrice,
    product,
    isBonusProduct,
    variant,
    alignment,
    loading
}) => {
    const {isEcommerceEnabled, showPricesOnContentOnly} = useCommerceData(product)

    const {price, displayPrice, hasDiscount, isFree} =
        useProductPricing(product, isBonusProduct) || {}

    // content only sites do not render prices
    if (!isEcommerceEnabled && !showPricesOnContentOnly) {
        return null
    }

    return (
        <Component
            price={price}
            displayPrice={displayPrice}
            hasDiscount={hasDiscount}
            isFree={isFree}
            loading={loading}
            variant={variant}
            alignment={alignment}
            currency={product?.currency}
        />
    )
}

ProductDisplayPrice.propTypes = {
    as: PropTypes.elementType,
    product: PropTypes.object,
    isBonusProduct: PropTypes.bool,
    loading: PropTypes.bool,
    variant: PropTypes.string,
    alignment: PropTypes.oneOf(['start', 'center', 'end'])
}

export default ProductDisplayPrice
